export default {
  promptDetailColor: '',
  styledButtonColor: '',
  styledButtonSVGFill: '',
};
